export default __webpack_public_path__ + "static/media/DNC-IVR.fc624dad.mp3";